export default "__VITE_ASSET__Chz2DCDZ__"